import React, { Component } from 'react';
import { Cascader, Col, DatePicker, Form, Input, Radio, Select } from 'antd';
import moment from 'moment';

import { queryCustomCategory } from '@api/crm/crm';
import SelectUser from '@comm/SelectUser';
import chinaAddressOptions from '@comm/cascader-address-options';

const { Option } = Select;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;

class ConfigItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    if (this.props.field.field.indexOf('category') < 0) {
      return;
    }
    const key = this.props.data.category1;
    queryCustomCategory().then(res => {
      if (res.statusCode === 200) {
        const data = res.data.map(item => {
          item.isLeaf = false;
          return item;
        });
        if (!key) {
          this.setState({
            category: data,
          });
          return;
        }
        queryCustomCategory(key).then(result => {
          if (result.statusCode === 200) {
            data.map(item => {
              if (item.key === key) {
                item.children = result.data;
              }
              return item;
            });
            this.setState({
              category: data,
            });
          }
        });
      }
    });
  }

  chaneRegion = value => {
    if (value.length > 0) {
      this.props.form.setFieldsValue({ province: value[0], city: value[1] });
    }
  };

  getName = key => {
    let name = '';
    switch (key) {
      case 'orderUuid':
        name = 'orderName';
        break;
      case 'managerUuid':
        name = 'managerName';
        break;
      case 'recommendUuid':
        name = 'recommendName';
        break;
      default:
        break;
    }
    return name;
  };

  handleSelectChangge = key => {
    const name = this.getName(key);
    return (value, selectedOptions) => {
      const params = {};
      params[name] = selectedOptions.props.children;
      this.props.form.setFieldsValue(params);
    };
  };

  getSelectedOptions = key => {
    this.state.category.filter(item => {
      return item.key === key;
    });
  };

  loadCategory = selectedOptions => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;

    queryCustomCategory(targetOption.value).then(req => {
      if (req.statusCode === 200) {
        targetOption.loading = false;
        targetOption.children = req.data;
      }
    });
  };

  chaneCategory = value => {
    if (value.length > 0) {
      this.props.form.setFieldsValue({
        category1: value[0],
        category2: value[1],
      });
    }
  };

  renderFormItem = field => {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    let ComponentRender = null;
    if (field.field === 'orderName') {
      field.field = 'orderUuid';
    } else if (field.field === 'managerName') {
      field.field = 'managerUuid';
    } else if (field.field === 'recommendName') {
      field.field = 'recommendUuid';
    }
    switch (field.field) {
      case 'establishedDate':
        ComponentRender = (
          <FormItem label={field.fieldName}>
            {getFieldDecorator('establishedDate', {
              rules: [
                {
                  required: field.isRequire,
                  message: `请输入${field.fieldName}!`,
                },
              ],
              initialValue: data.establishedDate
                ? moment.unix(data.establishedDate / 1000)
                : data.establishedDate,
            })(<DatePicker style={{ width: '100%' }} />)}
          </FormItem>
        );
        break;
      case 'type':
        ComponentRender = (
          <FormItem label={field.fieldName}>
            {getFieldDecorator('type', {
              rules: [
                {
                  required: field.isRequire,
                  message: `请选择${field.fieldName}!`,
                },
              ],
              initialValue: data.type ? `${data.type}` : data.type,
            })(
              <Select onChange={this.changeType}>
                <Option key="1" value="1">
                  公司
                </Option>
                <Option key="0" value="0">
                  个人
                </Option>
              </Select>,
            )}
          </FormItem>
        );
        break;
      case 'category':
        ComponentRender = (
          <FormItem label="客户行业">
            {getFieldDecorator('category', {
              rules: [
                {
                  required: field.isRequire,
                  message: `请输入${field.fieldName}!`,
                },
              ],
              initialValue: data.category,
            })(
              <Cascader
                options={this.state.category}
                loadData={this.loadCategory}
                onChange={this.chaneCategory}
                fieldNames={{
                  label: 'key',
                  value: 'value',
                  children: 'children',
                }}
                changeOnSelect
                placeholder="请选择客户行业"
              />,
            )}
          </FormItem>
        );
        break;
      case 'orderUuid':
      case 'recommendUuid':
      case 'managerUuid':
        ComponentRender = (
          <SelectUser
            onChange={() => this.handleSelectChangge(field.field)}
            field={field}
            {...this.props}
          />
        );
        break;
      case 'region':
        ComponentRender = (
          <FormItem label={field.fieldName}>
            {getFieldDecorator('region', {
              rules: [
                {
                  required: field.isRequire,
                  message: `请输入${field.fieldName}!`,
                },
              ],
              initialValue: data ? data.region : '',
            })(
              <Cascader
                options={chinaAddressOptions}
                onChange={this.chaneRegion}
                changeOnSelect
                placeholder="请选择地址"
              />,
            )}
          </FormItem>
        );
        break;
      case 'related':
        ComponentRender = (
          <FormItem label="是否有关联用户名">
            {getFieldDecorator('related', {
              rules: [
                {
                  required: field.isRequire,
                  message: `请输入${field.fieldName}!`,
                },
              ],
              initialValue: data ? data.related : '',
            })(
              <RadioGroup>
                <Radio value={0}>否</Radio>
                <Radio value={1}>是</Radio>
              </RadioGroup>,
            )}
          </FormItem>
        );
        break;
      default:
        ComponentRender = (
          <FormItem label={field.fieldName}>
            {getFieldDecorator(field.field, {
              rules: [
                {
                  required: field.isRequire,
                  message: `请输入${field.fieldName}!`,
                },
              ],
              initialValue: data ? data[field.field] : '',
            })(<Input />)}
          </FormItem>
        );
        break;
    }
    return ComponentRender;
  };

  render() {
    return <Col span={12}>{this.renderFormItem(this.props.field)}</Col>;
  }
}

export default ConfigItem;



// WEBPACK FOOTER //
// ./src/components/crm/custom/department/ConfigItem.js